export const WHAT_READ_NEXT_CARD_HEIGHT = '324px';
export const GAP_BETWEEN_ITEMS = 24;
export const CARD_ITEM_SETTINGS = {
    sm: {
        width: '328px',
    },
    md: {
        width: '438px',
    },
    lg: {
        width: '432px',
    },
};
export const REQUIRED_CARD_PROPS = ['title', 'link', 'image'];
